// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"45d07270","453":"01ff6806","732":"cf99fce9"}[chunkId] + ".chunk.js";
};